/* */ 
module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };